/* =========
  Helpers
========= */
function debounce(fn, wait = 150) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(null, args), wait);
  };
}

function clampQty(val, min, max) {
  let n = parseInt(val, 10);
  if (!Number.isFinite(n)) n = min;
  if (Number.isFinite(max)) n = Math.min(n, max);
  return Math.max(n, min);
}

/* =========
  <cart-form> (SINGLE handler, no duplicates)
========= */
if (!customElements.get('cart-form')) {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this._bound = false;
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
    }

    connectedCallback() {
	if (this._bound) return;
	this._bound = true;

	// CAPTURE => passe avant les listeners du thème/apps
	this.addEventListener('click', this.onClick, true);
	this.addEventListener('change', this.onChange, true);
	}

    getErrorsEl() {
      return this.querySelector('[data-cart-errors]');
    }

    clearError() {
      const el = this.getErrorsEl();
      if (!el) return;
      el.textContent = '';
      el.classList.add('hidden');
    }

    showError(msg) {
      const el = this.getErrorsEl();
      if (!el) return;
      el.textContent = msg;
      el.classList.remove('hidden');
    }

    setBusy(isBusy) {
      this.toggleAttribute('aria-busy', !!isBusy);
    }

    getItemEl(from) {
      return from.closest('[data-js-cart-item]');
    }

    getQtyInput(itemEl) {
      return itemEl ? itemEl.querySelector('input.qty') : null;
    }

    getMax(input) {
      if (!input) return Infinity;
      const maxAttr = input.getAttribute('max');
      if (!maxAttr) return Infinity;
      const m = parseInt(maxAttr, 10);
      return Number.isFinite(m) ? m : Infinity;
    }

    async changeItem(key, qty) {
      this.clearError();
      this.setBusy(true);

      try {
        const res = await fetch(`${(window.Shopify?.routes?.root) || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });

        let data = null;
        try { data = await res.json(); } catch (e) {}

        if (!res.ok) {
          this.showError(data?.description || "Erreur panier. Rafraîchis et réessaie.");
          return null;
        }

        return data;
      } catch (e) {
        this.showError("Erreur panier. Rafraîchis et réessaie.");
        return null;
      } finally {
        this.setBusy(false);
      }
    }

    async applyQty(itemEl, qty) {
      const key = itemEl?.dataset?.id; // item.key chez toi
      if (!key) return;

      // UI optimiste
      const input = this.getQtyInput(itemEl);
      if (input) input.value = String(qty);

      await this.changeItem(key, qty);

      // Source de vérité = Shopify => re-render via section
      if (typeof window.refreshCart === 'function') window.refreshCart();
    }

	onClick(e) {
  	const btnPlus  = e.target.closest('#AjaxCartForm [data-qty-plus]');
  	const btnMinus = e.target.closest('#AjaxCartForm [data-qty-minus]');
  	const removeLink = e.target.closest('#AjaxCartForm a.remove');

  	if (!btnPlus && !btnMinus && !removeLink) return;

	// On coupe l'autre JS du thème (sinon +2)
	if (e.stopImmediatePropagation) e.stopImmediatePropagation();
	e.stopPropagation();

	const itemEl = this.getItemEl(e.target);
	if (!itemEl) return;

	// Verrou anti double-run (au cas où)
	const now = Date.now();
	if (itemEl.__qtyLockTs && (now - itemEl.__qtyLockTs) < 300) return;
	itemEl.__qtyLockTs = now;

	// ... ensuite tu laisses TON code tel quel (remove / calc next / applyQty)

	// Remove (lien)
	if (removeLink) {
		e.preventDefault();
		this.applyQty(itemEl, 0);
		return;
	}
      e.preventDefault();

      const input = this.getQtyInput(itemEl);
      const max = this.getMax(input);
      const current = clampQty(input ? input.value : itemEl.dataset.qty || 0, 0, max);

      const next = btnPlus
        ? clampQty(current + 1, 0, max)
        : clampQty(current - 1, 0, max);

      if (next === current) return;
      this.applyQty(itemEl, next);
    }

    onChange(e) {
      const input = e.target.closest('input.qty');
      if (!input) return;

      const itemEl = this.getItemEl(input);
      if (!itemEl) return;

      const max = this.getMax(input);
      const next = clampQty(input.value, 0, max);
      input.value = String(next);

      this.applyQty(itemEl, next);
    }
  }

  customElements.define('cart-form', CartForm);
}

/* =========
  window.refreshCart (section helper-cart)
========= */
if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch(`?section_id=helper-cart&mbts=${Date.now()}`)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newForm = doc.getElementById('AjaxCartForm');
        const newSubtotal = doc.getElementById('AjaxCartSubtotal');
        if (!newForm) return;

        const cartFormEl = document.getElementById('AjaxCartForm');
        if (!cartFormEl) return;

        cartFormEl.innerHTML = newForm.innerHTML;

        document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
          const c = cartFormEl.querySelector('[data-cart-count]');
          if (c) elm.textContent = c.textContent;
        });

        document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
          const t = cartFormEl.querySelector('[data-cart-total]');
          if (t) elm.textContent = t.textContent;
        });

        if (newSubtotal && document.getElementById('AjaxCartSubtotal')) {
          document.getElementById('AjaxCartSubtotal').innerHTML = newSubtotal.innerHTML;
        }

        const drawer = document.querySelector('[data-js-site-cart-sidebar]');
        if (drawer && typeof drawer.show === 'function') drawer.show();

        const recos = document.querySelector('cart-recommendations');
        if (recos) {
          recos.innerHTML = '';
          if (typeof recos.generateRecommendations === 'function') recos.generateRecommendations();
        }
      });
  };
}

/* =========
  <cart-note>
========= */
if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body
            });
          }, 150)
        );
      }
    }
  );
}

if (!window.__MB_CART_ADD_HOOK__) {
  window.__MB_CART_ADD_HOOK__ = true;

  const _fetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const res = await _fetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const isAdd =
        url.includes('/cart/add') || url.includes('/cart/add.js') || url.includes('/cart/add.json');

      if (isAdd && res.ok) {
        // laisse le thème finir, puis refresh
        setTimeout(() => {
          if (typeof window.refreshCart === 'function') window.refreshCart();

          // si ton drawer existe, on le montre
          const drawer = document.querySelector('[data-js-site-cart-sidebar]');
          if (drawer && typeof drawer.show === 'function') drawer.show();
        }, 50);
      }
    } catch (_) {}

    return res;
  };
}

(function () {
  const isCartPage =
    location.pathname === '/cart' || location.pathname.startsWith('/cart/');
  if (!isCartPage) return;

  if (window.__MB_CART_PAGE_RELOAD_HOOK__) return;
  window.__MB_CART_PAGE_RELOAD_HOOK__ = true;

  let reloadLock = false;
  const doReload = () => {
    if (reloadLock) return;
    reloadLock = true;
    location.reload();
  };

  const _fetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const res = await _fetch(...args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const isCartMutation =
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add') ||
        url.includes('/cart/clear');

      if (isCartMutation && res.ok) {
        // Petite micro-latence pour laisser le thème finir ses DOM updates
        setTimeout(doReload, 50);
      }
    } catch (_) {}

    return res;
  };
})();